module.exports = __webpack_public_path__ + "static/media/pxiEyp8kv8JHgFVrJJfecnFHGPc.9212f6f9.woff2";